// angular imports
import { EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

// cc-imports
import {
    CCLocalStorageCategory,
    CCLocalStorageService,
    CCMessageBoxIcon,
    IconConstants,
    MessageBoxComponent,
    Utils
} from 'cc-common';

// devextreme imports
import notify from 'devextreme/ui/notify';

// component imports
import { WorkflowInvoiceHeaderDetailsEditorComponent } from '../../shared-workflow-module/components/workflow-invoice-header-details-editor/workflow-invoice-header-details-editor.component';
import { WorkflowStepLineItemEditorComponent } from '../components/workflow-step-line-item-editor/workflow-step-line-item-editor.component';

// service imports
import { UserService } from '../../_services/data-services/user.service';
import { FileReaderService } from '../../_services/shared-services/file-reader.service';
import { HelperService } from '../../_services/shared-services/helper.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { WorkflowEditorService } from '../_services/workflow-editor.service';
import { WorkflowEditorSharedService } from '../../shared-workflow-module/_services/workflow-editor-shared.service';

// model imports
import { WFEWorkflowRawDto } from '../../shared-workflow-module/_models/wfe-workflow-raw-dto';
import { WFEBaseParametersDto } from '../../shared-workflow-module/_models/wfe-base-parameter-dto';
import { WFEBankBalanceParameterDto } from '../_models/common/wfe-bank-balance-parameter-dto';
import { WFEBankBalanceResultDto } from '../_models/common/wfe-bank-balance-result-dto';
import { DimensionSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { WorkflowChecklistEditorResultDto } from '../../shared-workflow-module/_models/workflow-check-list-editor-result-dto';
import { WorkflowCheckListItemResultDto } from '../../shared-workflow-module/_models/workflow-check-list-item-result-dto';
import { WorkflowCheckListRawDto } from '../../shared-workflow-module/_models/workflow-check-list-raw-dto';
import { WFEWorkflowItemRawDto } from '../_models/workflow-data-entry/wfe-workflow-item-raw-dto';
import { WorkflowCheckListParametersDto } from '../../shared-workflow-module/_models/workflow-check-list-parameters-dto';
import { WorkFlowParametersDto } from '../../shared-workflow-module/_models/workflow-parameters-dto';
import { VendorCodingDefaultEditorParameterDto } from '../../shared-workflow-module/_models/vendor-coding-default-editor-parameter-dto';
import { VendorCodingDefaultEditorResultDto } from '../../shared-workflow-module/_models/vendor-coding-default-editor-result-dto';
import { WFVendorContractRawDto } from '../../vendor-management/shared-vendor-management-module/_models/wf-vendor-contract-raw-dto';
import { WfeVendorContractParametersDto } from '../_models/common/wfe-vendor-contract-parameters-dto';
import { WFEVendorParametersDto } from '../_models/common/wfe-vendor-parameter-dto';
import { WFEVendorAccountEFTActiveStatusParameterDto } from '../../shared-workflow-module/_models/wfe-vendor-account-eft-active-status-parameter-dto';
import { WFEVendorResultDto } from '../../shared-workflow-module/_models/wfe-vendor-result-dto';
import { WFEVendorAccountResultDto } from '../../shared-workflow-module/_models/wfe-vendor-account-result-dto';

// constants imports
import { StorageKeyConstants } from '../../_constants/storage-key-constants';
import { Constants } from '../../_constants/constants';
import { MessageInterval } from '../../_constants/messages-intervals';
import { WorkflowConstants } from '../../shared-workflow-module/_constants/worflow-constants';

export class MPBaseWorkflowApprovalComponent implements OnInit, OnDestroy {
    @ViewChild('workflowStepMessageBox', { static: false }) workflowMessageBox: MessageBoxComponent;
    @ViewChild('invoiceHeaderDetailEditor', { static: false })
    invoiceHeaderDetailEditor: WorkflowInvoiceHeaderDetailsEditorComponent;
    @ViewChild('workflowLineItemEditor', { static: false })
    workflowLineItemEditor: WorkflowStepLineItemEditorComponent;

    @Input() workflowId: number;
    @Input() isPopupMode: boolean;
    @Input() communityId: number;

    @Output() closeEditor = new EventEmitter<boolean>();
    @Output() splitterPositionChange = new EventEmitter<boolean>();
    @Output() hideSplitter = new EventEmitter<boolean>();
    @Output() pdfLoader = new EventEmitter<boolean>();
    @Output() pdfURL = new EventEmitter<string>();

    workflowEditor: WFEWorkflowRawDto;
    workOrderToComplete: Array<number> = [];
    dimensionSource: Array<DimensionSelectorResultDto>;
    bankBalance: number;

    userService: UserService;
    fileReaderService: FileReaderService;
    router: Router;
    helperService: HelperService;
    errorService: ServerErrorService;
    localStorageService: CCLocalStorageService;
    workflowEditorService: WorkflowEditorService;
    workflowEditorSharedService: WorkflowEditorSharedService;

    breadCrumbs: any[];

    separateWindow = false;
    pdfViewerToLeft = false;
    settingsMenu: object[] = [];

    pdfSource: string;
    pdfWindow: any;

    showDenyCam = false;
    invoiceAttachments: File[] = [];

    checklistItems: Array<WorkflowCheckListItemResultDto> = [];
    checkListEditor: WorkflowChecklistEditorResultDto;
    showVendorChecklist = false;
    isChecklistApprovable = false;
    workflowEditedChecklist: Array<WorkflowCheckListRawDto> = [];

    isDefaultCodingLineItemAvailable = false;
    isLineItemsTargetCommunityAvailable = false;

    isApproveAction = false;
    workflowStep: string;
    selectedVendorPayee: WFEVendorResultDto;
    selectedVendorPayeeAccount: WFEVendorAccountResultDto;

    showDenyConfirmation = false;
    showUpdateInReview = false;
    showBillAction = false;
    selectedBillAction: string;
    selectedBillParams: WorkFlowParametersDto = new WorkFlowParametersDto();
    showWorkOrder = false;
    showOnlyLinkedWorkOrder = false;
    showContracts = false;

    loadingVisible: boolean;

    iconNotes = IconConstants.NOTES_AVAILABLE;
    iconEmptyNotes = IconConstants.NOTES_EMPTY;
    iconPDF = IconConstants.PDF_FILE;
    iconHistory = IconConstants.HISTORY;
    iconClose = IconConstants.CLOSE;
    iconCheck = IconConstants.CHECK;
    iconDelete = IconConstants.DELETE;
    iconExclamation = IconConstants.EXCLAMATORY;
    iconHelp = IconConstants.HELP;
    iconNext = IconConstants.NEXT;
    iconSetting = IconConstants.SETTING;
    iconRandom = IconConstants.RANDOM;
    iconCross = IconConstants.CROSS;

    isValidWorkflowToApprove = false;

    constructor(protected readonly injector: Injector) {
        this.localStorageService = injector.get(CCLocalStorageService);
        this.workflowEditorService = injector.get(WorkflowEditorService);
        this.workflowEditorSharedService = injector.get(WorkflowEditorSharedService);
        this.userService = injector.get(UserService);
        this.fileReaderService = injector.get(FileReaderService);
        this.router = injector.get(Router);
        this.helperService = injector.get(HelperService);
        this.errorService = injector.get(ServerErrorService);
    }

    ngOnInit() {
        this.getSplitterContentPosition();
        this.workflowEditorSharedService.isDefaultLineItemAvailable().subscribe((isLineItemAvailable: boolean) => {
            this.isDefaultCodingLineItemAvailable = isLineItemAvailable;
        });
    }

    ngOnDestroy() {
        if (Utils.isFalse(this.isPopupMode)) {
            this.userService.updateSideNavigatorState(true);
        }
    }

    onPdfClick(): void {
        if (Utils.notNullOrEmpty(this.pdfWindow) && Utils.isFalse(this.pdfWindow.closed)) {
            this.pdfWindow.close();
        }
        this.pdfWindow = window.open(
            this.pdfSource,
            '_blank',
            'location=yes,height=670,width=620,scrollbars=yes,status=yes'
        );
    }

    onWorkflowClose(): void {
        this.closeOrExitWorkflowEditor(false);
    }

    setActiveBreadCrumb(selectedBread: string): void {
        this.breadCrumbs.forEach((d) => {
            if (Utils.equals(d.id, selectedBread)) {
                d.selected = true;
            }
        });
    }

    getDefaultsComponentValues(): void {
        this.getWorkflowInvoice(true);
        if (Utils.equalsIgnoreCase(this.workflowEditor.payeeType, WorkflowConstants.PAYEE_TYPE_VENDOR)) {
            this.getVendors();
        } else {
            this.selectedVendorPayee = null;
            this.selectedVendorPayeeAccount = null;
        }
    }

    resetWorkflow(): void {
        if (Utils.notNullOrEmpty(this.pdfWindow)) {
            this.pdfWindow.close();
        }
    }

    populateBankBalance(bankAccountId: number): void {
        const baseParams: WFEBankBalanceParameterDto = new WFEBankBalanceParameterDto();
        baseParams.bankAccountId = bankAccountId;
        baseParams.communityId = this.workflowEditor.communityId;

        this.workflowEditorService.getBankBalance(baseParams).subscribe(
            (result: WFEBankBalanceResultDto) => {
                this.bankBalance = result.bankBalance;
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    closeOrExitWorkflowEditor(forceReload: boolean): void {
        this.workflowId = null;
        this.communityId = null;
        if (Utils.isTrue(this.isPopupMode)) {
            this.closeAndNotifyParent(forceReload);
        } else {
            this.closeAndNavigate();
        }
    }

    onDenyClick(): void {
        this.showDenyCam = true;
    }

    onDenyCAMClose(): void {
        this.showDenyCam = false;
    }

    getEditedChecklist(
        checklistItems: Array<WorkflowCheckListItemResultDto>,
        workflowStep: string
    ): Array<WorkflowCheckListRawDto> {
        const editedCheckList: Array<WorkflowCheckListRawDto> = [];
        for (const item of checklistItems) {
            const obj: WorkflowCheckListRawDto = new WorkflowCheckListRawDto();
            obj.id = item.id;
            obj.status = item[`${workflowStep}Status`];
            obj.comments = item[`${workflowStep}Comments`];
            if (Utils.notNullOrEmpty(obj.status)) {
                editedCheckList.push(obj);
            } else {
                break;
            }
        }

        this.isChecklistApprovable = Utils.equals(this.checklistItems.length, editedCheckList.length);
        return editedCheckList;
    }

    onVendorChecklistClose(): void {
        this.showVendorChecklist = false;
    }

    checkIfTargetCommunityAvailable(modifiedLineItems: WFEWorkflowItemRawDto[]): void {
        const targetCommunityExistInLineItem = modifiedLineItems.find((d) => !!d.targetCommunityId);
        if (Utils.notNullOrEmpty(targetCommunityExistInLineItem)) {
            this.isLineItemsTargetCommunityAvailable = true;
        }
    }

    saveCheckList(checkListItems: Array<WorkflowCheckListRawDto>, workflowStep: string): void {
        const baseParam: WorkflowCheckListParametersDto = new WorkflowCheckListParametersDto();
        baseParam.workflowId = this.workflowId;
        baseParam.communityId = this.communityId;
        baseParam.workflowChecklistStatuses = checkListItems;

        this.workflowEditorSharedService.saveWorkflowChecklist(baseParam, workflowStep).subscribe(
            (result: any) => {
                notify(
                    `Check List for ${this.workflowId} is saved successfully.`,
                    'Success',
                    MessageInterval.successMsgInterval
                );
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    reclassBill(workflowStep: string): void {
        this.loadingVisible = true;
        this.workflowEditorSharedService.reclassBill(this.workflowEditor, workflowStep).subscribe(
            (result: any) => {
                notify('Successfully Reclassified.', 'Success', MessageInterval.successMsgInterval);
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    updateBill(workflowStep: string): void {
        this.loadingVisible = true;
        this.workflowEditorSharedService.updateBill(this.workflowEditor, workflowStep).subscribe(
            (result: any) => {
                notify('Bill successfully updated.', 'Success', MessageInterval.successMsgInterval);
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    populateCodingDefaultEditor(workflowStep: string): void {
        const baseParam: VendorCodingDefaultEditorParameterDto = new VendorCodingDefaultEditorParameterDto();
        baseParam.communityId = this.communityId;
        baseParam.workflowId = this.workflowId;
        baseParam.vendorAccountId = this.workflowEditor.vendorAccountId;
        baseParam.payeeCode = this.workflowEditor.payeeCode;
        baseParam.clearCache = true;

        this.workflowEditorSharedService.getCodingDefaultEditor(baseParam, workflowStep).subscribe(
            (result: VendorCodingDefaultEditorResultDto) => {
                this.isDefaultCodingLineItemAvailable = Utils.notNullOrEmpty(result.lineItemTemplates);
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    onWorkOrderClick(): void {
        this.showOnlyLinkedWorkOrder = false;
        this.showWorkOrder = true;
    }

    onWorkOrderSelectorClose(): void {
        this.showWorkOrder = false;
    }

    onContractsClick(): void {
        this.showContracts = true;
    }

    onSaveWorkflowVendorContractClick(workflowVendorContracts: Array<WFVendorContractRawDto>): void {
        if (Utils.notNullOrEmpty(workflowVendorContracts)) {
            const baseParam: WfeVendorContractParametersDto = new WfeVendorContractParametersDto();
            baseParam.workflowId = this.workflowEditor.workflowId;
            baseParam.communityId = this.workflowEditor.communityId;
            baseParam.vendorContracts = workflowVendorContracts;

            this.workflowEditorService.saveWorkflowVendorContracts(baseParam).subscribe(
                () => {
                    notify(
                        'Workflow Vendor Contracts Successfully Saved.',
                        'Success',
                        MessageInterval.successMsgInterval
                    );
                    this.showContracts = false;
                },
                (error) => {
                    this.errorService.displayError(error);
                }
            );
        }
    }

    onEFTValueChanged(eftValue: boolean): void {
        if (
            Utils.notNullAndDefined(eftValue) &&
            Utils.equalsIgnoreCase(this.workflowEditor.payeeType, WorkflowConstants.PAYEE_TYPE_VENDOR) &&
            Utils.notNullOrEmpty(this.selectedVendorPayee) &&
            Utils.isFalse(this.selectedVendorPayee.isEFTVendor) &&
            Utils.notNullAndDefined(this.selectedVendorPayeeAccount) &&
            Utils.notEquals(this.selectedVendorPayeeAccount.eftActive, eftValue)
        ) {
            const eftState = Utils.isTrue(eftValue) ? `Active` : 'Inactive';
            const confirmationMessage = `Do you wish to set EFT Flag for the Vendor Account to ${eftState}?`;
            const dialog = this.helperService.getConfirmationDialog('Confirmation', confirmationMessage);
            dialog.show().then((answer) => {
                if (Utils.isTrue(answer)) {
                    const baseParams: WFEVendorAccountEFTActiveStatusParameterDto =
                        new WFEVendorAccountEFTActiveStatusParameterDto();
                    baseParams.communityId = this.workflowEditor.communityId;
                    baseParams.eftActive = eftValue;
                    baseParams.payeeCode = this.workflowEditor.payeeCode;
                    baseParams.vendorAccountId = this.workflowEditor.vendorAccountId;
                    baseParams.workflowId = this.workflowEditor.workflowId;
                    this.workflowEditorSharedService.updateVendorAccountEFT(baseParams).subscribe(
                        () => {
                            notify(
                                'Vendor Account EFT successfully updated',
                                'Success',
                                MessageInterval.successMsgInterval
                            );
                            this.getVendorAccounts(true);
                        },
                        (error) => {
                            this.errorService.displayError(error);
                        }
                    );
                }
            });
        }
    }

    private getWorkflowInvoice(clearCache = false): void {
        const baseParams: WFEBaseParametersDto = new WFEBaseParametersDto();
        baseParams.workflowId = this.workflowId;
        baseParams.communityId = this.communityId;
        baseParams.workflowStatus = this.workflowEditor.status;
        baseParams.clearCache = clearCache;

        if (Utils.isFalse(this.separateWindow)) {
            this.pdfLoader.emit(true);
        }
        this.workflowEditorService.downloadWorkflowInvoice(baseParams).subscribe(
            (result: Blob) => {
                if (Utils.notNullAndDefined(result)) {
                    const fileURL: string = this.helperService.getFileUrlFromBlob(result);
                    this.pdfSource = fileURL;
                    this.pdfURL.emit(fileURL);
                    if (Utils.isFalse(this.separateWindow)) {
                        this.pdfLoader.emit(false);
                    } else {
                        this.onPdfClick();
                    }
                }
            },
            (error) => {
                if (error.status === 404) {
                    this.showAPIErrorMessage(
                        error,
                        'Something went wrong, We are unable to find the invoice. Please try again later.'
                    );
                } else {
                    this.showAPIErrorMessage(error);
                }
                this.pdfSource = null;
                this.pdfURL.emit(null);
                if (Utils.isFalse(this.separateWindow)) {
                    this.pdfLoader.emit(false);
                }
            }
        );
    }

    private showAPIErrorMessage(error: HttpErrorResponse, prefixMessage = ''): void {
        let message = error.error;

        if (Utils.notNullOrEmpty(prefixMessage)) {
            if (Utils.equals(error.status, 404)) {
                prefixMessage = '';
            }
        }

        if (Utils.equals(error.status, 409)) {
            // conflict
            // API usually returns this error status when a lock could not be obtained for workflow

            if (Utils.isNullOrEmpty(message)) {
                message = 'Could not lock work flow. Please try again after 30 minutes.';
            }

            this.workflowMessageBox.showWithFixedWidthAndIcon(
                CCMessageBoxIcon.error,
                'Error',
                prefixMessage + message,
                320
            );
        } else {
            this.errorService.displayError(error, prefixMessage);
        }
    }

    private closeAndNotifyParent(forceReload: boolean): void {
        this.resetWorkflow();
        this.pdfSource = null;
        this.pdfLoader.emit(false);

        // Notify Parent
        this.workflowEditorService.updateSubjectRefreshWorkflow(forceReload);

        // Close Parent
        this.closeEditor.emit(forceReload);
    }

    private closeAndNavigate(): void {
        // if isPopUpMode = false
        if (
            Utils.notNullOrEmpty(window.frameElement) &&
            Utils.notNullOrEmpty((window.frameElement as any).onWorkflowEditorFinish)
        ) {
            (window.frameElement as any).onWorkflowEditorFinish(true);
        }

        this.resetWorkflow();
        this.pdfSource = null;
        this.pdfLoader.emit(false);
        this.router.navigate(['/home']);
    }

    private getSplitterContentPosition(): void {
        this.separateWindow = false;
        this.pdfViewerToLeft = JSON.parse(
            this.localStorageService.getItem(StorageKeyConstants.wfInvoiceViewerPosition, CCLocalStorageCategory.WFE) ||
                String(Constants.splitterPDFViewerToLeft)
        );
        this.setSettingsMenu();
        this.splitterPositionChange.emit(this.pdfViewerToLeft);
    }

    private getVendors(): void {
        const baseParam: WFEBaseParametersDto = new WFEBaseParametersDto();
        baseParam.communityId = this.workflowEditor.communityId;
        baseParam.workflowId = this.workflowEditor.workflowId;
        baseParam.workflowStatus = this.workflowEditor.status;

        this.workflowEditorService.getWorkflowEditorVendors(baseParam).subscribe(
            (results: WFEVendorResultDto[]) => {
                if (
                    Utils.notNullAndDefined(this.workflowEditor) &&
                    Utils.notNullOrEmpty(this.workflowEditor.payeeCode)
                ) {
                    const selectedVendor = results.find((d) =>
                        Utils.equalsIgnoreCase(d.vendorCode, this.workflowEditor.payeeCode)
                    );
                    if (Utils.notNullAndDefined(selectedVendor) && Utils.isFalse(selectedVendor.isEFTVendor)) {
                        this.selectedVendorPayee = selectedVendor;
                        this.getVendorAccounts(false);
                    }
                }
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private getVendorAccounts(clearCache: boolean): void {
        const baseParam: WFEVendorParametersDto = new WFEVendorParametersDto();
        baseParam.communityId = this.workflowEditor.communityId;
        baseParam.vendorCode = this.workflowEditor.payeeCode;
        baseParam.workflowId = this.workflowEditor.workflowId;
        baseParam.workflowStatus = this.workflowEditor.status;
        baseParam.clearCache = clearCache;

        this.workflowEditorService.getWorkflowVendorAccount(baseParam).subscribe(
            (results: WFEVendorAccountResultDto[]) => {
                if (
                    Utils.notNullAndDefined(this.workflowEditor) &&
                    Utils.notNullOrEmpty(this.workflowEditor.vendorAccountId)
                ) {
                    const selectedVendorAccount = results.find((d) =>
                        Utils.equals(d.id, this.workflowEditor.vendorAccountId)
                    );

                    if (Utils.notNullAndDefined(selectedVendorAccount)) {
                        this.selectedVendorPayeeAccount = selectedVendorAccount;
                    }
                }
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private setSettingsMenu(): void {
        const settingsMenu = [
            {
                text: 'Show Invoice On Right Pane',
                visible: Utils.isTrue(this.pdfViewerToLeft),
                onClick: () => {
                    this.pdfViewerToLeft = false;
                    this.splitterPositionChange.emit(this.pdfViewerToLeft);
                    this.setSettingsMenu();
                }
            },
            {
                text: 'Show Invoice On Left Pane',
                visible: Utils.isFalse(this.pdfViewerToLeft),
                onClick: () => {
                    this.pdfViewerToLeft = true;
                    this.splitterPositionChange.emit(this.pdfViewerToLeft);
                    this.setSettingsMenu();
                }
            },
            {
                text: 'Separate Window',
                visible: Utils.isFalse(this.separateWindow),
                onClick: () => {
                    this.separateWindow = true;
                    this.hideSplitter.emit(this.separateWindow);
                    this.onPdfClick();
                    this.changeSettingsMenu();
                }
            }
        ];

        this.settingsMenu = settingsMenu;
    }

    private changeSettingsMenu(): void {
        const settingsMenu = [
            {
                text: 'Show Side by Side Panel',
                onClick: () => {
                    this.separateWindow = false;
                    this.hideSplitter.emit(this.separateWindow);
                    this.setSettingsMenu();
                }
            }
        ];

        this.settingsMenu = settingsMenu;
    }
}
